import { Card, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import CompletedTaskTable from "../../../components/NP/Payment/CompletedTaskTable";
import Subheader from "../../../components/ui/Subheader";
import { ArrayOption, selectSearchOption } from "../../../helpers/siteConfig";
import useModal from "../../../hooks/useModal";
import AdminLayout from "../../../layouts/AdminLayout";
import {
  getAllAreaAsync,
  getAllRegionAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import { getSinglePOForVendorAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CreditCardItem } from "../../../types/redux/NP/supplier";
import { formatSouthAsianNumber } from "../../../utils/number";

export default function CompletedTask() {
  const [regionId, setRegionId] = useState<string | undefined>(undefined);
  const [areaId, setAreaId] = useState<string | undefined>(undefined);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const dispatch = useAppDispatch();
  const {
    open: addOpen,
    toggle: addToggle,
    handleOpen: handleAddOpen,
  } = useModal();
  const { login } = useAppSelector((state) => state.login);
  const { regions, areas } = useAppSelector((state) => state.npGeo);
  const { getSinglePOForVendor } = useAppSelector((state) => state.supplier);

  const creditCards: CreditCardItem[] = [
    {
      title: "Total PO Value",
      value: `৳${
        getSinglePOForVendor?.carryForwardBalance
          ? formatSouthAsianNumber(
              getSinglePOForVendor?.carryForwardBalance +
                getSinglePOForVendor?.initialMoney
            )
          : "0"
      }`,
    },
    {
      title: "Remaining PO Value",
      value: `৳${
        getSinglePOForVendor?.remainingPoBalance
          ? formatSouthAsianNumber(getSinglePOForVendor?.remainingPoBalance)
          : "0"
      }`,
    },
    {
      title: "PO Value Used",
      value: `${
        getSinglePOForVendor?.calculatedUsagePercentage
          ? formatSouthAsianNumber(
              getSinglePOForVendor?.calculatedUsagePercentage
            )
          : "0"
      }%`,
    },
  ];

  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  useEffect(() => {
    if (regionId)
      dispatch(
        getAllAreaAsync({
          params: {
            region: regionId,
          },
        })
      );
  }, [dispatch, regionId]);

  useEffect(() => {
    if (login?.role === "vendor") {
      dispatch(getSinglePOForVendorAsync());
    }
  }, [dispatch, login?.role]);

  useEffect(() => {
    if (login?.role === "region") {
      setRegionId(login?.region);
    }
  }, [dispatch, login?.region, login?.role]);

  return (
    <>
      <AdminLayout title="Payment Summary" headerTitle="Payment">
        {login?.role === "vendor" && (
          <section className="mt-7">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {creditCards.map((card, index) => (
                <Card className="shadow border-none bg-[#F0F3F9]" key={index}>
                  <div className="justify-start text-body text-base font-medium pb-2.5">
                    {card.title}
                  </div>
                  <div className="justify-start text-body text-3xl font-semibold">
                    {card.value}
                  </div>
                </Card>
              ))}
            </div>
          </section>
        )}

        <section className="mt-7">
          <Subheader title="Payment Summary" subTitle={""}>
            <Space size="middle" className="flex-wrap">
              {login?.role === "vendor" && (
                <>
                  <Select
                    // value={regionId}
                    placeholder="Cluster"
                    allowClear
                    showSearch
                    filterOption={selectSearchOption}
                    options={ArrayOption(regions, "regionName", "_id", true)}
                    onChange={(val) => {
                      setRegionId(val);
                      setAreaId(undefined);
                    }}
                    className="min-w-[120px]"
                    // disabled={login?.role === "vendor"}
                  />
                  <Select
                    placeholder="Zone"
                    allowClear
                    showSearch
                    filterOption={selectSearchOption}
                    options={ArrayOption(areas, "areaName", "_id", true)}
                    onChange={(val) => {
                      setAreaId(val);
                    }}
                    value={areaId}
                    disabled={!regionId}
                    className="min-w-[120px]"
                  />

                  {/* <Select
                    placeholder="Last 7 Days"
                    allowClear
                    showSearch
                    // filterOption={selectSearchOption}
                    // options={ArrayOption(allSupplier, "supplierName", "_id")}
                    // onChange={(val) => {
                    //   setSupplierId(val);
                    // }}
                    // value={supplierId}
                    // disabled={!areaId}
                    className="min-w-[120px]"
                    optionFilterProp="children"
                  /> */}

                  {/* <Button
                    type="primary"
                    onClick={() =>
                      handleAddOpen({
                        type: "ADD_TO_BATCH_PAYMENT",
                      })
                    }
                    disabled={selectedRowKeys.length === 0}
                  >
                    Add to Batch Payment
                  </Button> */}
                </>
              )}

              {/* {login?.role === "region" && (
                <Select
                  placeholder="Today"
                  allowClear
                  showSearch
                  // filterOption={selectSearchOption}
                  // options={ArrayOption(allSupplier, "supplierName", "_id")}
                  // onChange={(val) => {
                  //   setSupplierId(val);
                  // }}
                  // value={supplierId}
                  // disabled={!areaId}
                  className="min-w-[120px]"
                  optionFilterProp="children"
                />
              )} */}
            </Space>
          </Subheader>

          <CompletedTaskTable
            addOpen={addOpen}
            addToggle={addToggle}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            filter={{
              regionId,
              areaId,
            }}
          />
        </section>
      </AdminLayout>
    </>
  );
}
